// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {isLoading} from './isLoading'
import {getError} from './getError'

export const gbiProjectSelectors = {
  isLoading,
  getError,
}
